import React from 'react';
import TicketsPage from '../components/TicketsPage';

const TicketsApp = (props) => (
  <TicketsPage {...props} />
);

export default TicketsApp;
